exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-invoice-details .card-invoice {\n  width: 100% !important;\n}\n.modal-invoice-details .elevation-1 {\n  margin-bottom: 0px !important;\n}\n.modal-invoice-details .header-nf {\n  border-bottom: 1px solid var(--v-gray-base);\n}\n.modal-invoice-details .header-nf .info-nf {\n  border-right: 1px solid var(--v-gray-base);\n}\n.modal-invoice-details .orange--text {\n  color: #ff9800 !important;\n  caret-color: #ff9800 !important;\n}\n", ""]);

// exports
